const listEnabled = [
    'активен', 'не активен'
]

export default class WorkerUtil {

    static convertStatus(status) {
        return status === true ? listEnabled[0] : listEnabled[1];
    }

    static convertWorkers(workers) {
        // Если workers null, undefined или не массив, или пустой — возвращаем пустую строку
        if (!workers || !Array.isArray(workers) || workers.length === 0) {
            return "";
        }

        const validWorkers = workers.filter(worker =>
            worker && worker.lastName // Только валидные объекты с lastName
        );

        if (validWorkers.length === 0) {
            return "";
        }

        return validWorkers.map(worker => {
            const lastName = worker.lastName || '';
            const firstNameInitial = worker.firstName && worker.firstName.trim().length > 0
                ? worker.firstName.trim()[0] + '.'
                : '';
            const middleNameInitial = worker.middleName && worker.middleName.trim().length > 0
                ? worker.middleName.trim()[0]
                : '';

            // Собираем строку без лишних пробелов
            let parts = [lastName];
            if (firstNameInitial) parts.push(firstNameInitial);
            if (middleNameInitial) parts.push(middleNameInitial);

            return parts.join(' ');
        }).join(', ');
    }

    static convertWorker(worker) {
        return worker.lastName + ' ' + worker.firstName + ' ' + worker.middleName;
    }
}
